module.exports = __webpack_public_path__ + "img/icon_map_8_on_111.9cc49965.png";